<div class="bcg p-4 ">
    <div class="row">
        <div class="col-lg-7 col-sm-7 col-md-7">
            <p class="nav_link_cat ms-1  flex_row">
                <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
                <span [style.font-weight]="'bold'"> >> </span>
                <span>Reports Detailed</span>
            </p>
        </div>
        <div class="col-lg-1 col-sm-1 col-md-1 "></div>
        <div class="col-lg-3 col-sm-3 col-md-3 overlay text-right">
            <app-dropdown class="custom-dropdown text-left" placeholder={{displayBranch}} [options]="states"
                [(ngModel)]="selectedState" (click)=getSelected() optionLabel="name"></app-dropdown>
        </div>
    </div>

    <div class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-1 col-sm-1 col-md-1">
                    <p-button icon="bx bx-menu" (click)="visibleSidebar = true"
                        styleClass="p-button-sm-outline"></p-button>
                </div>
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="title_five">Total Orders</h5>
                    <p class="card-text text_p ">View Detailed Report of the Orders</p>
                </div>
                <div class="col-lg-5 col-sm-5 col-md-5 text-right custom_button">
                    <p-button label="Export Excel" (click)="export()" icon="bx bx-export"
                        styleClass="p-button-sm-outline"></p-button>
                    <p-button class="ms-1" label="Back" [routerLink]="['/doqfy/dashboard']"
                        styleClass="p-button-sm-outline"></p-button>

                </div>
            </div>
        </div>
    </div>
    <div class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row mt-2">
                <div class="col-lg-2 col-sm-2 col-md-2 overlay_Z_0">
                    <app-dropdown class="custom-dropdown text-left" [options]="states" [(ngModel)]="selectedState"
                        (click)=getSelected() placeholder="Select State" optionLabel="label"></app-dropdown>
                </div>
                <div class="col-lg-2 col-sm-2 col-md-2 overlay_Z_0">
                    <app-dropdown class="custom-dropdown text-left" [options]="states" [(ngModel)]="selectedState"
                        (click)=getSelected() placeholder="Select Branch" optionLabel="name"></app-dropdown>
                </div>
                <div class="col-lg-2 col-sm-2 col-md-2 overlay_Z_0">
                    <app-dropdown class="custom-dropdown text-left" [options]="states" [(ngModel)]="selectedState"
                        (click)=getSelected() placeholder="Select User" optionLabel="label"></app-dropdown>
                </div>
                <div class="col-lg-1 col-sm-1 col-md-1"></div>
                <div class="col-lg-3 col-sm-3 col-md-3 text-right  overlay" style="padding-right: 5px;">
                    <p-datepicker #calendar class="custom-calendar" [(ngModel)]="rangeDates" maxDate="currentData"
                        (onSelect)="onSelect()" placeholder="Filter Range" [showIcon]="true" iconDisplay="input" selectionMode="range"
                        [readonlyInput]="false" inputId="range" dateFormat="dd/mm/yy">
                    </p-datepicker>

                </div>
                <div class="col-lg-2 col-sm-2 col-md-2 overlay">
                    <span>
                        <p-datepicker class="custom-calendar" [(ngModel)]="selectedDate" icon="bx bxs-calendar"
                            placeholder="Select Month" view="month" dateFormat="MM yy" [showIcon]="true" iconDisplay="input"
                            [readonlyInput]="false" inputId="monthpicker">
                        </p-datepicker>
                    </span>
                </div>


            </div>
        </div>
    </div>


</div>
<div class="pt-4">
    <p-drawer class="sideBarReport" [(visible)]="visibleSidebar">
        <li class="box">
            <div class="title_five_1 clickable">Total Orders</div>
        </li>
        <li class="box">
            <div class="title_five_1 clickable">Cancelled Orders</div>
        </li>
        <li class="box">
            <div class="title_five_1 clickable">CAT Edit Orders</div>
        </li>
        <li class="box">
            <div class="title_five_1 clickable">CAT Upload Orders</div>
        </li>
        <li class="box">
            <div class="title_five_1 clickable">Esign Detials</div>
        </li>
        <li class="box">
            <div class="title_five_1 clickable">Estamp Details</div>
        </li>
        <li class="box">
            <div class="title_five_1 clickable">Statewise Amount Balance</div>
        </li>
        <li class="box">
            <div class="title_five_1 clickable">Stamp Inventory</div>
        </li>
    </p-drawer>
</div>